import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LeagueSettingService {
  private http = inject(HttpClient);

  constructor() { }

  /**
   * Create league
  */
  update(leagueId, type, value) {
    return this.http.post<any>('api_endpoint' + '/league/update-settings', { leagueId, type, value });
  }
}
